module.exports = __webpack_public_path__ + "static/media/traversiere-logo.9cdd148e.png";